import { createFileRoute } from '@tanstack/react-router';

import { getCompetitorQueryOptions } from '@/_pages/competitors/api-service';
import Loading from '@/_pages/competitors/contacts/loading';

export const Route = createFileRoute('/_private/competitors/_template/$id/contacts')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompetitorQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Contacts',
    tabKey: 'competitor/contacts',
  },
  pendingComponent: Loading,
});
